import { useEffect, useRef, useState } from "react"
import Input from "../../blocks/Input"
import { useForm } from "../../hooks/useForm"
import { ajax } from "../../scripts/helper"
import utils from "../../scripts/utils"
import './calculator.css'
import { useSnackbar } from 'notistack'
import { useNavigate } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const CalculatorForm = () => {

    const { enqueueSnackbar } = useSnackbar()
    const [calculated, setCalculated] = useState(false)
    const navigate = useNavigate();
    const [focused, setFocused] = useState(false)
    const [rateFocused, setRateFocused] = useState(false)
    const [printData, setPrintData] = useState({})
    const [currencyValue, setCurrencyValue] = useState()
    const [inputCurrencyValue, setInputCurrencyValue] = useState('');
    const [currencyOptions, setCurrencyOptions] = useState([]);


    const [paymentCurrencyValue, setPaymentCurrencyValue] = useState()
    const [inputPaymentCurrencyValue, setInputPaymentCurrencyValue] = useState('');
    const [paymentCurrencyOptions, setPaymentCurrencyOptions] = useState([]);

    const [inputFields, handleChange, setInputFields] = useForm({
        pnr: {
            name: 'pnr',
            type: 'text',
            value: '',
            placeholder: 'PNR...'
        },
        segment: {
            name: 'segment',
            value: '',
            type: 'select',
            items: [],
            selected: null
        },
        rate: {
            name: 'rate',
            value: '',
            type: 'number',
            placeholder: 'Excess Rate'
        },
        contact: {
            name: 'contactPerson',
            value: '',
            type: 'text',
            placeholder: 'passenger'
        },
        mobile: {
            name: 'mobile',
            value: '',
            type: 'text',
            placeholder: 'mobile'
        },
        email: {
            name: 'email',
            value: '',
            type: 'text',
            placeholder: 'email'
        },
        excessAmount: {
            name: 'excessAmount',
            value: '',
            type: 'text',
            placeholder: 'Excess Amount'
        },
        currency: {
            name: 'currency',
            value: '',
            type: 'select',
            items: [],
            selected: null
        },
        amount: {
            name: 'amount',
            value: '',
            type: 'text',
            placeholder: 'Excess Amount'
        },
        paymentCurrency:{
            name: 'paymentCurrency',
            value: '',
            items: [],
            selected: null,
            type: 'select',
        },
        vat: {
            name: 'vat',
            value: '',
            type: 'number',
            placeholder: 'VAT Rate'
        },
        excessTotalAmount: {
            type: 'text',
            value: '',
            name: 'excessTotalAmount'
        },
        OriginalBookingCurrency: {
            name: 'OriginalBookingCurrency',
            value: '',
            type: 'text'
        },
        bookingExchangeRate: {
            name: 'bookingExchangeRate',
            type: 'text',
            value: ''
        },
        equiv: {
            name: 'equiv',
            type: 'text',
            value: ''
        },
        vatAmount: {
            name: 'VAT amount',
            type: 'text',
            value: ''
        },
        totalAmountVAT: {
            name: 'totalAmountVAT',
            type: 'text',
            value: ''
        },
        paymentExchangeRate: {
            name: 'paymentExchangeRate',
            type: 'text',
            value: ''
        },
        payableAmount: {
            name: 'payableAmount',
            type: 'text',
            value: ''
        },
        resPaymentCurrency: {
            name: 'resPaymentCurrency',
            type: 'text',
            value: ''
        }
        

    })

    useEffect( () => {
        if(inputCurrencyValue.trim()) fetchCurrency()
        
    }, [inputCurrencyValue])
    useEffect( () => {
        if(inputPaymentCurrencyValue.trim()) fetchPaymentCurrency()
        
    }, [inputPaymentCurrencyValue])


    const fetchCurrency = async() => {

        const response = await ajax({
            method: 'GET',
            url: utils.urls.searchCurrency(inputCurrencyValue),
            hasToken: true,
            snackbar: enqueueSnackbar
        })

        if(!response) return

        setCurrencyOptions(response.data)

    }


    const fetchPaymentCurrency = async() => {

        const response = await ajax({
            method: 'GET',
            url: utils.urls.searchCurrency(inputPaymentCurrencyValue),
            hasToken: true,
            snackbar: enqueueSnackbar
        })

        if(!response) return

        setPaymentCurrencyOptions(response.data)

    }

    


    const checkTab = async (e) => {
        if(e.keyCode === 9 && inputFields.pnr.value || e.type === 'blur') {
            const response = await ajax({
                method: 'GET',
                url: utils.urls.excessbaggagePnr(inputFields.pnr.value),
                hasToken: true,
                snackbar: enqueueSnackbar
            })

            if(!response) return 

            if(response.data.segments.length === 0 ) {
                setInputFields({
                    ...inputFields,
                    contact: {
                        ...inputFields.contact,
                        value: ''
                    },
                    mobile: {
                        ...inputFields.mobile,
                        value: ''
                    },
                    email: {
                        ...inputFields.email,
                        value: ''
                    },
                    segment: {
                        items: [],
                        selected: null,
                    }
                })
                return
            }
            const segmentItems = response.data.segments.map(segment => {
                return {
                    label: segment,
                    data: segment,
                    id: segment
                }
            })

            setInputFields({
                ...inputFields,
                segment: {
                    ...inputFields.segment,
                    selected: null,
                    items: segmentItems,
                    value: ''
                },
                contact: {
                    ...inputFields.contact,
                    value: response.data.primaryContact
                },
                mobile: {
                    ...inputFields.mobile,
                    value: response.data.mobile
                },
                email: {
                    ...inputFields.email,
                    value: response.data.email
                }
            })
            await setFocused(false)
            setRateFocused(true)
        }

        
    }

    const handleSegmentDropDown = async (segment) => {
        const res = await ajax({
            method: 'GET',
            hasToken: true,
            url: utils.urls.currencies,
            snackbar: enqueueSnackbar
        })

        if(!res) return 

        const currencyItems = res.data.content.map( currency => {
            return {
                label: currency.code,
                id: currency.id,
                data: currency
            }
        })

        const office = JSON.parse( window.localStorage.getItem('userInfo'))

        let officeCurrency = currencyItems.findIndex(e => e.id === office.office.currency.id)
        if(officeCurrency === -1) {
            currencyItems.push({
                label: office.office.currency.code,
                id: office.office.currency.id,
                data: office.office.currency
            })

            officeCurrency = currencyItems.findIndex(e => e.id === office.office.currency.id)
        }

        const response = await ajax({
            method: 'GET',
            hasToken: true,
            snackbar: enqueueSnackbar,
            url: utils.urls.segmentRate(segment)
        })


        if(!response) {
            
            setInputFields({
                ...inputFields,
                paymentCurrency: {
                    ...inputFields.paymentCurrency,
                    selected: office.office.currency.id,
                    value: office.office.currency,
                },
                vat: {
                    ...inputFields.vat,
                    value: (currencyItems[officeCurrency].label === 'IRR' ? 10 : 0)
                },
                segment: {
                    ...inputFields.segment,
                    selected: segment,
                    value: segment
                },
                rate: {
                    ...inputFields.rate,
                    value: ''
                }
            })


            return
        }


        setInputCurrencyValue(response.data.currency.code)

        const selectedCurrency =  currencyItems.findIndex(el => el.id === response.data.currency.id )
        setInputFields({
            ...inputFields,
            rate: {
                ...inputFields.rate,
                value: response.data.rate
            },
            currency: {
                ...inputFields.currency,
                selected: response.data.currency.id,
                value: response.data.currency
            },
            paymentCurrency: {
                ...inputFields.paymentCurrency,
                selected: office.office.currency.id,
                value: office.office.currency,
            },
            vat: {
                ...inputFields.vat,
                value: (currencyItems[officeCurrency].label === 'IRR' ? 10 : 0)
            },
            segment: {
                ...inputFields.segment,
                selected: segment,
                value: segment
            }
        })
        setRateFocused(false)
        setFocused(true)
    }

    const handleCurrencyDropdown = (currency) => {

        const index = inputFields.currency.items.findIndex(el => el.id === currency.id)

        setInputFields({
            ...inputFields,
            currency: {
                ...inputFields.currency,
                value: inputFields.currency.items[index].label,
                selected: inputFields.currency.items[index].id
            }
        })
    }

    const handlePaymentCurrencyDropdown  = (currency) => {

        setInputFields({
            ...inputFields,
            paymentCurrency: {
                ...inputFields.paymentCurrency,
                value: currency.code,
                selected: currency.id
            },
            vat: {
                ...inputFields.vat,
                value: (currency.code === 'IRR' ? 9 : 0 )
            }
        })

    }

    const calculateExcessBaggage = async () => {
        setCalculated(false)

        const {pnr, rate, segment, amount, currency, paymentCurrency, vat} = inputFields


        const data = {
            "reference": pnr.value.toUpperCase(),
            "segment": segment.value,
            "excessRate": rate.value,
            "excessRateCurrencyId": currency.selected,
            "excessWeight": parseInt(amount.value),
            "paymentCurrencyId": paymentCurrency.selected,
            "vatRate": vat.value
        }

        setPrintData(data)

        const response = await ajax({
            method: 'POST',
            url: utils.urls.excessbaggageCalculator,
            hasToken: true,
            snackbar: enqueueSnackbar,
            data
        })

        if(!response) return

        setCalculated(true)

        setInputFields({
            ...inputFields,
            excessTotalAmount: {
                ...inputFields.excessTotalAmount,
                value: response.data.excessTotal
            },
            OriginalBookingCurrency: {
                ...inputFields.OriginalBookingCurrency,
                value: response.data.bookingCurrency.code
            },
            bookingExchangeRate: {
                ...inputFields.bookingExchangeRate,
                value: response.data.excessBookingExchangeRate.toLocaleString()
            },
            equiv: {
                ...inputFields.equiv,
                value: response.data.excessEquiv.toLocaleString()
            },
            vatAmount: {
                ...inputFields.vatAmount,
                value: response.data.vatAmount.toLocaleString()
            },
            totalAmountVAT: {
                ...inputFields.totalAmountVAT,
                value: response.data.totalVatInclusive.toLocaleString()
            },
            paymentExchangeRate: {
                ...inputFields.paymentExchangeRate,
                value: response.data.paymentExchangeRate.toLocaleString()
            },
            payableAmount: {
                ...inputFields.payableAmount,
                value: response.data.totalPayable.toLocaleString()
            },
            resPaymentCurrency: {
                ...inputFields.resPaymentCurrency,
                value: response.data.paymentCurrency.code
            }
        })

    }

    const goToPayment = () => {
        navigate('/agent/payments/single', {state: {type: 'create', ref: 'calculator', data: inputFields}})
    }

    const goToPos = () => {
        navigate('/agent/payments/pos-payment',  {state: {type: 'create', ref: 'calculator', data: inputFields}})
    }

    const print = async() => {
        const response = await ajax({
            method: 'POST',
            url: utils.urls.excessbaggageReceipt,
            hasToken: true,
            snackbar: enqueueSnackbar,
            data: printData
        })

        const wind = window.open()
        wind.document.write(response.data)
        wind.document.close()
    }

    return (
        <>
            <div className="row">
                <div className="first">
                    <label>PNR</label>
                    <Input inputField={inputFields.pnr} onChange={handleChange}  handleBlur={e => checkTab(e)}/>
                </div>
                <div className="first" id="1">
                    <label>Segment</label>
                    <Input inputField={inputFields.segment} onChange={handleChange} onClickDropdownItem={handleSegmentDropDown} focused={rateFocused}/>
                </div>
                <div className="first" id="failed">
                    <label>Rate Per KG</label>
                    <Input inputField={inputFields.rate} onChange={handleChange} />
                </div>
                <div className="first">
                    <label>Currency</label>
                    <Autocomplete 
                    sx={{ width: "100%" }}
                    renderInput={(params) => <TextField {...params} />}
                    getOptionLabel={ (option) =>  option ? option.code : ''}
                    options={currencyOptions}
                    autoComplete
                    includeInputInList
                    filterSelectedOptions
                    value={inputFields.currency.value}
                    noOptionsText="No currency"
                    onChange={(event, newValue) => {
                        setCurrencyValue(newValue?.id);
                        setInputFields({
                            ...inputFields,
                            currency: {
                                ...inputFields.currency,
                                selected: newValue?.id,
                                value: newValue
                            }
                        })
                    }}
                    onInputChange={(event, newInputValue) => {
                        if(newInputValue.trim())
                            setInputCurrencyValue(newInputValue)
                    }}
                    renderOption={(props, option) => <li {...props}>{option.code}</li>}

                  />
                </div>
            </div>
            <div className="row">
                <div className="second">
                    <label>Primary contact</label>
                    <Input inputField={inputFields.contact} onChange={handleChange} />
                </div>
                <div className="second">
                    <label>Mobile</label>
                    <Input inputField={inputFields.mobile} onChange={handleChange} />
                </div>
                <div className="second">
                    <label>Email</label>
                    <Input inputField={inputFields.email} onChange={handleChange} />
                </div>
            </div>
            <div className="row">
                <div className="second">
                    <label>Excess Weight (KG)</label>
                    <Input inputField={inputFields.amount} onChange={handleChange} focused={focused}/>
                </div>
                <div className="second">
                    <label>Payment Currency</label>
                    <Autocomplete 
                    sx={{ width: "100%" }}
                    renderInput={(params) => <TextField {...params} />}
                    getOptionLabel={ (option) =>  option ? option.code : ''}
                    options={paymentCurrencyOptions}
                    autoComplete
                    includeInputInList
                    filterSelectedOptions
                    value={inputFields.paymentCurrency.value}
                    noOptionsText="No currency"
                    onChange={(event, newValue) => {
                        setPaymentCurrencyValue(newValue?.id);
                        setInputFields({
                            ...inputFields,
                            paymentCurrency: {
                                ...inputFields.paymentCurrency,
                                selected: newValue?.id,
                                value: newValue
                            }
                        })
                    }}
                    onInputChange={(event, newInputValue) => {
                        if(newInputValue.trim())
                            setInputPaymentCurrencyValue(newInputValue)
                    }}
                    renderOption={(props, option) => <li {...props}>{option.code}</li>}

                  />
                </div>
                <div className="second">
                    <label>VAT Rate</label>
                    <Input inputField={inputFields.vat} onChange={handleChange} />
                </div>
            </div>
            <div className="row">
                <div className="calculate-btn">
                    <button onClick={calculateExcessBaggage}>CALCULATE</button>
                </div>
            </div>

            {
                calculated && 
                <>
                <div className="devider"></div>
                <div className="row">
                    <div className="second">
                        <label>Excess Total Amount</label>
                        <Input inputField={inputFields.excessTotalAmount} onChange={handleChange} readOnly={true}/>
                    </div>
                    <div className="second">
                        <label>Original Booking Currency</label>
                        <Input inputField={inputFields.OriginalBookingCurrency} onChange={handleChange} readOnly={true}/>
                    </div>
                    <div className="second">
                        <label>Exchange Rate ({inputFields.currency.value.code} --- {inputFields.OriginalBookingCurrency.value})</label>
                        <Input inputField={inputFields.bookingExchangeRate} onChange={handleChange} readOnly={true}/>
                    </div>
                </div>
                <div className="row">
                    <div className="third">
                        <label>Excess Equiv. Amount</label>
                        <Input inputField={inputFields.equiv} onChange={handleChange} readOnly={true}/>
                    </div>
                    <div className="third">
                        <label>VAT Amount</label>
                        <Input inputField={inputFields.vatAmount} onChange={handleChange} readOnly={true}/>
                    </div>
                </div>
                <div className="row">
                    <div className="second">
                        <label>Total Amount (VAT Inclusive)</label>
                        <Input inputField={inputFields.totalAmountVAT} onChange={handleChange} readOnly={true}/>
                    </div>
                    <div className="second">
                        <label>Payment Currency</label>
                        <Input inputField={inputFields.resPaymentCurrency} onChange={handleChange} readOnly={true}/>
                    </div>
                    <div className="second">
                        <label>Exchange Rate ({inputFields.OriginalBookingCurrency.value} --- {inputFields.paymentCurrency.value.code})</label>
                        <Input inputField={inputFields.paymentExchangeRate} onChange={handleChange} readOnly={true}/>
                    </div>
                </div>
                <div className="row">
                    <div className="second">
                        <label>Total Payable Amount</label>
                        <Input inputField={inputFields.payableAmount} onChange={handleChange} readOnly={true}/>
                    </div>
                    
                </div>
                <div className="row">
                    <div className="calculate-option-button-container">
                        <button onClick={() => goToPayment()}>Create Link</button>
                        <button onClick={() => goToPos()}>Create POS Link</button>
                        <button onClick={() => print()}>Print Calculation</button>
                    </div>
                </div>
                </>

            }
        </>

    )
}

export default CalculatorForm